import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Guarantee } from './Guarantee';
const includes = ['The 6-Volume Professional AI Prompt System', '120 Ready-to-Customize Prompts', 'Security Report Writing Framework', 'Patrol & Site Operations Framework', 'Shift Management & Handovers Framework', 'Risk Assessment & Prevention Framework', 'Communication & Client Service Framework', 'Supervision, Training & Compliance Framework', '4 Professional Bonuses Included', 'Seven-Day Money-Back Guarantee, subject to the stated terms', 'Lifetime Access & Free Updates'];
const trust = [{
  icon: LockIcon,
  label: 'Secure checkout'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Any device'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="w-full scroll-mt-16 bg-ink" data-id="element-164" data-mp="3c78holxwvzub">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingBottom: "19px",
      paddingTop: "11px"
    }} data-id="element-165" data-mp="3w08dc5xidi9b">
        <div className="mx-auto mb-7 max-w-lg text-center" data-id="element-166" data-mp="4s4cnegayxjh">
          <h2 className="font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-167" data-mp="9s8pmui05a4y">🔥 The Complete Private Security AI Toolkit</h2>
          <p className="mt-2 text-sm text-fog/70" data-id="element-168" data-mp="eqabtoaq5pkn">Get the main system and all four complementary bonuses in one digital package.</p>
        </div>

        <div className="relative mx-auto w-full max-w-lg overflow-hidden rounded-3xl border border-gold/50 bg-ink-2 shadow-[0_30px_70px_-30px_rgba(224,180,76,0.45)]" data-id="element-169" data-mp="3d74fe8d9cj8w">
          <div className="border-b border-gold/40 bg-ink-3 px-6 py-4 text-center" data-id="element-170" data-mp="3n5k9mk7l08mm">
            <h3 className="font-display text-lg font-bold uppercase tracking-wide text-gold" data-id="element-171" data-mp="3rywtyi589t9k">
              The 100+ AI Prompts for Private Security™
            </h3>
          </div>

          <div className="px-6 pb-7 pt-5 text-center" data-id="element-172" data-mp="2zgr9ebjxfem7">
            <p className="text-sm text-fog/65" data-id="element-173" data-mp="2zfg8qkls2mzb">
              <span className="font-semibold text-fog" data-id="element-174" data-mp="2rg37ec3e0ero">Ideal for:</span> Security Officers, Site Supervisors, Team Leaders,
              Operations Managers, and Security Company Operators who want practical tools for reports, operations,
              handovers, and communication.
            </p>

            <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-fog/50" data-id="element-175" data-mp="2w7bh798mq25d">Your complete package includes</p>
            <ul className="mt-4 space-y-2.5 text-left" data-id="element-176" data-mp="28iipxq2ycih3">
              {includes.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-fog/85" data-id="element-177" data-mp="23jp85lgmu5b4">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-178" data-mp="2igputajyva2q" />
                  {f}
                </li>)}
            </ul>

            <div className="mt-8 border-t border-line pt-6" data-id="element-179" data-mp="2djg3tqgxiqcs">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-fog/50" data-id="element-180" data-mp="3tts8nxuollj7">Your one-time investment</p>
              <p className="mt-2 text-lg font-medium text-fog/40 line-through" data-id="element-181" data-mp="3ovz6rh0evdoq">$54</p>
              <p className="flex items-start justify-center font-display leading-none text-teal" data-id="element-182" data-mp="8sqt1wrcclo">
                <span className="mt-2 text-4xl font-bold" data-id="element-183" data-mp="5b1k5zdjlgob">$</span>
                <span className="text-[80px] font-bold" data-id="element-184" data-mp="3nfv2s6hoa3ns">27</span>
                <span className="mt-auto pb-3 pl-1 text-lg font-semibold text-fog/70" data-id="element-185" data-mp="3nhfyhzfq3sn8">USD</span>
              </p>
              <p className="mt-2 text-xs font-semibold text-fog/70" style={{
              fontSize: "11px"
            }} data-id="element-186" data-mp="j151cbxkek6w">· One-time payment · Lifetime Access ·</p>
              <p className="mt-1 text-center text-[11px] font-medium text-fog/55" data-id="element-187" data-mp="nyn23f1fht3t">· Payment will be processed in your local currency ·</p>
            </div>

            <div className="mt-6 flex justify-center" data-id="element-188" data-mp="e9wrxfw8iytq">
              <CTAButton size="md" data-id="element-189" data-mp="e8loxiam5v3o">Get 100+ AI Prompts for Private Security™ now</CTAButton>
            </div>
            <p className="mt-3 text-[13px] font-bold text-gold" data-id="element-190" data-mp="11yg0lwj75dmc">Save $27 (50% off)</p>
            <p className="mt-1 text-[11px] text-fog/50" data-id="element-191" data-mp="16s0notj94n6r">Payment currency and available payment methods are determined by the checkout.</p>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-fog/60" data-id="element-192" data-mp="3a8ffindfrqg2">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-193" data-mp="35b5qh8tylgsr">
                  <Icon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-194" data-mp="319k6l3j0c292" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>

        <Guarantee data-id="element-195" data-mp="3szyhcqvq4ygi" />
      </div>
    </section>;
}